import { Flex } from "@chakra-ui/react";
import { Activities } from "src/modules/activity-log/activity";
import SvgContainer from "src/components/SvgContainer";
import { ReactComponent as VideoIconOn } from "../icons/video-mode-on.svg";
import { ReactComponent as VideoIconOff } from "../icons/video-mode-off.svg";

export default function VideoModeButton({ activity, mode, onClick }) {
  const isSleeping = activity === Activities.SLEEPING;
  const isInVideoMode = mode === "video";
  return (
    <Flex
      onClick={onClick}
      bg={
        isInVideoMode
          ? "rgba(0, 0, 0, 0.2)"
          : isSleeping
          ? "iconBackground"
          : "rgba(0, 0, 0, 0.2)"
      }
      zIndex={9999}
      position="fixed"
      top="12px"
      right="48px"
      borderRadius="100%"
      alignItems="center"
      justifyContent="center"
      padding="4px"
      sx={{
        WebkitAppRegion: "no-drag"
      }}
    >
      <SvgContainer
        fill={isInVideoMode ? "white" : isSleeping ? "mediumEmphasis" : "white"}
        icon={isInVideoMode ? VideoIconOff : VideoIconOn}
      />
    </Flex>
  );
}
